<div class="edit-blended-model-allocations-component" id="edit-blended-model-allocations-component" >
  <div class="block">
    @if (rowCount !== 0) {
      <div class="assignAccountsCountText" >
        <span id="securitiesRowcount">{{rowCount}}</span>
        component security models
      </div>
    }
  </div>

  <div>
    <div class="block">Add a component model for this Blended model:</div>
    <irb-dropdown-search-multiple #securityModelsDropdown
      (search)="getSecurityModelsFiltered($event)"
      [(values)]="securityModelsList"
      (selection)="onAddModelsChange($event)"
      style="width: 300px !important;vertical-align: middle;" size="30">
    </irb-dropdown-search-multiple>
    <button (click)="addModelsFromDropdown()"
      [disabled]="securityModelsList ? securityModelsList.length === 0 : true" class="btn-medium-secondary">
      Add
    </button>
  </div>

  @if (!isUiTest) {
    <irb-inventory-grid id="edit-blended-model-allocation-grid"
      [style.height] = "height"
      [showSideBar] ='true'
      [gridOptions] = "gridOptions"
      [rowSelection]="'single'"
      [suppressRowClickSelection] ="false"
      [componentName]="'BlendedModelsAllocationsComponent-v001'"
      [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)">
    </irb-inventory-grid>
  }

  <div class="edit-blended-model-allocation-totas-row" >
    <div style="position: relative;margin-bottom:10px;">
      Total Component Model Allocations:
      <div style="position: absolute;top: 5px;text-align:right;padding-right:11px;"
        id="edit-blended-model-allocation-grid-totalper"
      [style]="{color: totalPercent === 100 ? '#188800' : '#C11312'}"></div>
    </div>

    @if (data) {
      <div style="display: none;align-items: center;font-weight: bold;position: relative;">
        <button (click)="getFinMasonScore()"
          [disabled]="totalPercent === 100 ? false : true"
        class="btn-medium-secondary">Get</button>
        <div style="padding:0 10px;" >FinMason FinScore:</div>
        <div class="infoIcon" style="padding:0 10px;" calltoaction [calltoactionTemplate]="irbFinScoreTemplateRef">
          <div class="infoIcon" style="margin-left: 10px;padding-right:14px;"></div>
        </div>
        <ng-template #irbFinScoreTemplateRef >
          <div [innerHTML]="finscoreToolTip"></div>
        </ng-template>
        <div style="position: absolute;top: 3px;left:230px;text-align:right;padding-right:11px;" id="edit-secallocation-finscore-totalper">{{ finScore }}</div>
      </div>
    }

  </div>

</div>
